import { render, staticRenderFns } from "./SingleSignOnSaml.vue?vue&type=template&id=19a823f5"
import script from "./SingleSignOnSaml.vue?vue&type=script&lang=js"
export * from "./SingleSignOnSaml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports